import { useContext, useEffect, useRef, useState } from 'react'
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import { Bar, Doughnut, getElementAtEvent } from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import { CPlaceholder } from '@coreui/react-pro';
import { ChartJSOrUndefined } from 'react-chartjs-2/dist/types';
import { IReportGraph } from '../../types/entities/report';
import useToast from '../../hooks/toast';
import {generateDistinctRgbaColors, GenericErrorHandler, RandomNumber} from "../../utils/misc";
import { AppContext } from '../../contexts/App';
import { REPORTS_GRAPH_DOUGHNUT } from '../../constants/endpoint';

export default function GraphDoughnut() {
    const [searchParams] = useSearchParams();
    const [data, setData] = useState<IReportGraph[]>([])
    const [loading, setloading] = useState(true)
    const navigate = useNavigate();
    const chartRef = useRef<ChartJSOrUndefined<"doughnut", (number | [number, number] | null)[], unknown>>();
    const [addToast] = useToast()
    const { eye } = useContext(AppContext)
    const [colors, setColors] = useState<string[]>([])

    useEffect(() => {
        setloading(true)
        api.get(`${REPORTS_GRAPH_DOUGHNUT}?${searchParams.toString()}`).then(onfulfilled => {
            setData(onfulfilled.data)
            setColors(generateDistinctRgbaColors(onfulfilled.data.length))
            setloading(false)
        }).catch(reason => {
            GenericErrorHandler({reason, addToast})
        });
    }, [addToast, searchParams])

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        BarElement,
        Title,
        Tooltip,
        Legend,
        ArcElement
    );

    const chart_data: ChartData<'doughnut'> = {
        labels: data.map(x => x.label) || [],
        datasets: [
          {
            label: 'Debit',
            data: data.map(x => x.debit - x.kredit) || [],
            backgroundColor: colors,
            borderWidth: 1,
          },
          {
            label: 'Kredit',
            data: data.map(x => x.kredit) || [],
            backgroundColor: colors,
            borderWidth: 1,
          },
        ],
      }

    const chart_options: ChartOptions<'doughnut'> = {
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    afterBody: (tooltipItems) => {
                        return [
                            `${tooltipItems[0].dataset.data[tooltipItems[0].dataIndex] / tooltipItems[0].dataset.data.reduce((acc, curr) => Number(acc) + Number(curr), 0) * 100} %`
                        ];
                    }
                }
            }
        },
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event, element) => {
            (event?.native?.target as HTMLElement).style.cursor = element.length > 0 ? 'pointer' : 'auto'
        },
        // onClick: (event, element) => {
        //     if (element.length > 0) {
        //         const selected = data[element[0].index]
        //         const sp = createSearchParams(searchParams)
        //         sp.delete('rule')
        //         sp.set('tanggal_after', selected.min)
        //         sp.set('tanggal_before', selected.max)
        //         navigate({
        //             pathname: '/cashflow',
        //             search: sp.toString()
        //         })
        //     }
        // }
    }

    if (loading) return (<CPlaceholder animation="glow">
        <CPlaceholder xs={12} size="lg" />
    </CPlaceholder>)
    else return (
        <Doughnut
            
            
            // width={data.length * 70}
            data={chart_data}
            options={chart_options}
            // onClick={(event) => {
            //     const element = getElementAtEvent(chartRef.current as ChartJS<'doughnut'>, event)
            //     if (element.length > 0) {
            //         const selected = data[element[0].index]
            //         const sp = createSearchParams(searchParams)
            //         sp.delete('rule')
            //         sp.set('date_after', selected.min)
            //         sp.set('date_before', selected.max)
            //         sp.set('is_active', 'true' )
            //         sp.set('ordering', '-nominal' )
            //         navigate({
            //             pathname: '/cashflow',
            //             search: sp.toString()
            //         })
            //     }
            // }}
        />
    )
}
